import api from './api';
import { PotenzialKunde, UpdatePotenzialKundeRequest, GeoJsonImportResult, PotenzialImportLog, PotenzialExportModus } from '../types';

export const potenzialService = {
  async getAll(): Promise<PotenzialKunde[]> {
    const response = await api.get<PotenzialKunde[]>('/potenziale');
    return response.data;
  },

  async getById(id: number): Promise<PotenzialKunde> {
    const response = await api.get<PotenzialKunde>(`/potenziale/${id}`);
    return response.data;
  },

  async updateStatus(id: number, request: UpdatePotenzialKundeRequest): Promise<PotenzialKunde> {
    const response = await api.patch<PotenzialKunde>(`/potenziale/${id}/status`, request);
    return response.data;
  },

  async getImportLog(): Promise<PotenzialImportLog[]> {
    const response = await api.get<PotenzialImportLog[]>('/potenziale/imports');
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/potenziale/${id}`);
  },

  async deleteAll(): Promise<number> {
    const response = await api.delete<{ geloescht: number }>('/potenziale');
    return response.data.geloescht;
  },

  async exportPdf(modus: PotenzialExportModus, ids: number[]): Promise<void> {
    const response = await api.post('/potenziale/export-pdf', { modus, ids }, {
      responseType: 'blob',
      timeout: 120000,
    });

    const disposition = response.headers['content-disposition'];
    let filename = 'Potenzialliste.pdf';
    if (disposition) {
      const match = disposition.match(/filename[^;=\n]*=([^;\n]*)/);
      if (match && match[1]) filename = match[1].replace(/['"]/g, '').trim();
    }

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },

  async importGeoJson(file: File): Promise<GeoJsonImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post<GeoJsonImportResult>('/potenziale/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
    return response.data;
  },
};
